import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getQueryParam } from '../routing/getQueryParam';
import enviro from 'enviro';
import { getIsExistingUserSession } from '../store/app/selectors';
export const isAdditionalFlowsEnabled = () => {
  const isQA = enviro.isQa();
  const additionalFlows = [Flow.CmsFree, Flow.Purchase, Flow.Academy, Flow.Developers, Flow.CmsDevelopers, Flow.Commerce];
  const additionalFlowsEnabled = getQueryParam('additional_flows') === 'true';
  const isOnAdditionalFlow = additionalFlows.includes(getFlowKey());
  return isOnAdditionalFlow && additionalFlowsEnabled && isQA;
};
export const isExistingUserFlowEnabled = state => {
  const isQA = enviro.isQa();
  const existingUserFlowEnabled = getQueryParam('existing_user_flow') === 'true';
  const isExistingUserFlow = getIsExistingUserSession(state);
  return isExistingUserFlow && isQA && existingUserFlowEnabled;
};